import {
  TEXT_NOTIFICATION_FETCH_SUCCESS,
  DOWNLOAD_TEXT_NOTIFICATION_SUCCESS
} from '../constant/actionType';

const initialState = {
  csv: null,
  isLoaded: false,
  textNotifications: []
};

const textNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEXT_NOTIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        textNotifications: action.data
      };

    case DOWNLOAD_TEXT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default textNotificationReducer;
